import {Product, Variant} from "../../../../models/product";
import {Component, h} from "preact";
import {connect} from "redux-zero/preact";
import actions from "../../../../store/actions";
import styles from './style.module.scss';
import {productService} from "../../../../services/product-service";
import ProductBrand from "../../../product-brand";
import Button from "../../../button";
import {icons} from "../../../icons";
import Colors from "../../../colors";
import {i18nService} from "../../../../services/i18n-service";
import MatchingProducts from "../../../matching-products";
import {customerService} from "../../../../services/customer-service";
import {Like} from "../../../../models/customer";
import {NY_CountryService} from "../../../../services/country-service";
import App from "../../../app";
import {Dimension} from "../../../../services/tracking-service";
import {ProductPrice} from "../../../product-price";
import {config} from "../../../../config";
import {shortenerSerivce} from "../../../../services/shortener-service";

interface Props {
  toggleLike(variant: Variant, newLikeState: boolean, dimension: string);

  product: Product;
  variant: Variant;

  likes: Like[];
}

interface State {
  showShareButtons: boolean;
  isLiked: boolean;
}

const mapToProps = ({likes}) => ({likes});

class ProductInfoMobile extends Component<Props, State> {

  state: State = {
    showShareButtons: false,
    isLiked: false
  };

  async componentDidMount() {
    this.updateLikeState();
  }

  componentDidUpdate(previousProps: Readonly<Props>, previousState: Readonly<State>, previousContext: any): void {
    if (this.state.isLiked !== customerService.isVariantLiked(this.props.variant, this.props.likes)) {
      this.updateLikeState();
    }
  }

  private updateLikeState() {
    if (this.props.variant) {
      this.setState({isLiked: customerService.isVariantLiked(this.props.variant, this.props.likes)})
    }
  }

  private canShare() {
    return !!navigator.share;
  }

  private async share() {
    const shareURL = await shortenerSerivce.shorten(`${config.shareBasePath}/product/${this.props.variant.productId}/${this.props.variant.id}?country=${App.countryCode}`);
    const colorName = this.getColorTranslation(this.props.variant);

    await navigator.share({
      title: `${i18nService.translate(productService.getTranslationKey(this.props.product))} | ${colorName} | NEW YORKER`,
      url: shareURL.shortUrl
    });
  }

  private getColorTranslation(variant: Variant) {
    let key = (variant.colorGroup ? `colorgroup_${variant.colorGroup}` : `filter_color_${variant.basicColor}`).toLowerCase();
    return i18nService.translate(key);
  }

  render() {
    const variant = this.props.variant;
    return (
      <div>
        <div class={styles['product-info']}>
          <div class={styles.description}>
            {i18nService.translate(productService.getTranslationKey(this.props.product))}
          </div>

          <ProductPrice variant={variant} styles={styles}/>

          <div class={styles['brand-product-number']}>
            <div class={styles.brand}>
              <ProductBrand product={this.props.product}/>
            </div>
            <div class={styles['product-number']}>
              {variant.productId}
            </div>
          </div>

          {NY_CountryService.getCountryCode() == "fr" && <>
            <div className={styles['separator']}/>
            <div class={styles['epr']}>
              <a href={"/legal/Extended_Producer_Responsibility_FR.pdf"} target={"_blank"}>{i18nService.translate("detail_view_epr_label")}</a>
            </div>
          </>}

          <div class={styles.separator}/>

          <div class={styles['like-share']}>
            {!NY_CountryService.isRestricted(App.countryCode) && <div class={styles['like']}>
              <Button svg={icons.renderHeartIcon()}
                      label={i18nService.translate(this.state.isLiked ? 'detail_view_dislike_button' : 'detail_view_like_button')}
                      onClickCallback={this.handleToggleLike.bind(this)}
                      black={!this.state.isLiked}
                      grey={this.state.isLiked}/>
            </div>}

            {this.canShare() &&
              <div className={`${!NY_CountryService.isRestricted(App.countryCode) ? styles['share'] : styles['only-share']} `}>
                <Button label={i18nService.translate('detail_view_share_button')}
                        onClickCallback={this.share.bind(this)} white={true}/>
              </div>
            }
          </div>

          <div class={styles.separator}/>
        </div>
        <Colors product={this.props.product} selected={variant}/>
        <MatchingProducts productId={variant.productId} variantId={variant.id} isMobile={true}/>
      </div>
    )
  }

  async handleToggleLike (e: Event) {
    e.stopPropagation();

    await this.props.toggleLike(this.props.variant, !this.state.isLiked, Dimension.DETAIL);
    this.updateLikeState();
  }
}

export default connect(mapToProps, actions)(ProductInfoMobile)
